export default "__VITE_PUBLIC_ASSET__8c4e4899__"